
Vue.component("CanvasImage", {
    props: ["loaderId", "imageId"],
    template: `
        <div class="CanvasImage">
            <canvas ref="canvas"></canvas>
        </div>
    `,
    mounted() {

        const targetCanvas = app.imageStore.getImage(this.loaderId, this.imageId).content;


        this.$refs.canvas.width = targetCanvas.width;
        this.$refs.canvas.height = targetCanvas.height;
        this.ctx = this.$refs.canvas.getContext('2d');



        this.ctx.drawImage(targetCanvas, 0, 0);
    }
})